import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { createColumnHelper } from "@tanstack/react-table";
import { renderValue } from "utils/renderCompanyCell";
import { formatHandle } from "utils/helper";

const CreatorColumns = () => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("name", {
      header: "Name",
      size: 193,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("gender", {
      header: "Gender",
      size: 73,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("ig_handle", {
      header: "Instagram",
      size: 144,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-handle",
      enableSorting: false,
      cell: (info) => {
        const clean = formatHandle(info.getValue());
        if (!clean) return "-";

        return (
          <a
            className="handle-link"
            href={`https://instagram.com/${clean}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            @{clean}
          </a>
        );
      }
    }),
    columnHelper.accessor("yt_handle", {
      header: "YouTube",
      size: 144,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-handle",
      enableSorting: false,
      cell: (info) => {
        const clean = formatHandle(info.getValue());
        if (!clean) return "-";

        return (
          <a
            className="handle-link"
            href={`https://youtube.com/${clean}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            @{clean}
          </a>
        );
      }
    }),
    columnHelper.accessor("type", {
      header: "Type",
      size: 120,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-cell",
      enableSorting: false,
      cell: (info) => {
        const type = info.getValue();
        const styles = TYPE_STYLES[type] || {};
        return (
          <span
            className="type-badge"
            style={{
              color: styles.color,
              borderColor: styles.borderColor,
              border: `1px solid ${styles.borderColor}`,
              backgroundColor: styles.backgroundColor
            }}
          >
            {renderValue(type?.replace("_", " "))}
          </span>
        );
      }
    }),
    columnHelper.accessor("manager_name", {
      header: "Manager Name",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("created_at", {
      header: "Created At",
      size: 193,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    })
  ];
};

export default CreatorColumns;

export const TYPE_STYLES = {
  celebrity: {
    color: "#008491",
    borderColor: "#008491",
    backgroundColor: "#ECF5F6"
  },
  influencers: {
    color: "#6267E6",
    borderColor: "#6267E6",
    backgroundColor: "#F3F3FD"
  },
  meme_pages: {
    color: "#F60432",
    borderColor: "#F60432",
    backgroundColor: "#FDF4F4"
  },
  publishers: {
    color: "#EF0078",
    borderColor: "#EF0078",
    backgroundColor: "#FDEDF5"
  }
};
